import React from 'react';

import { cityOverrides } from '../../../store/constants/locationInfo';

import HistoricalText from './historical-text.component';
import ProjectionText from './projection-text.component';
import HazardText from './hazard-text.component';
import HurricaneText from './hurricane-api-text';
import StationText from './station-text.component';

const constructTitle = (loc) => {
  let cityOrCounty = '';
  let stateStr = '';
  if (loc.state) {
    stateStr = loc.state;
    if (cityOverrides.includes(loc.id)) {
      cityOrCounty = ' City, ';
    } else {
      cityOrCounty = ' County, ';
    }
  }

  return loc.name + cityOrCounty + stateStr;
};

export default function generateLocalText(
  loc,
  isClimate,
  chartTab,
  isChartVisible,
  useHurricaneApi,
  useStationData
) {
  let textComponent, title;
  if (useStationData) {
    // title = station stuff
    textComponent = <StationText />;
  } else {
    title = constructTitle(loc);
    if (useHurricaneApi) {
      textComponent = <HurricaneText place={title} />;
    } else if (isClimate) {
      textComponent =
        chartTab === 'historical' || !isChartVisible ? (
          <HistoricalText place={title} />
        ) : (
          <ProjectionText place={title} chartTab={chartTab} />
        );
    } else {
      textComponent = <HazardText place={title} />;
    }
  }

  return {
    title,
    children: textComponent,
  };
}
